import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=0be8d82b"
import script from "./file-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./file-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=0be8d82b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports